<template>
  <div class="profile-card-section">
    <h5 v-if="title" :style="titleColor ? { color: titleColor } : undefined">{{ title }}</h5>
    <ScrollOverflow class="cards" is-horizontal>
      <slot />
    </ScrollOverflow>
  </div>
</template>

<script setup lang="ts">
import ScrollOverflow from '@/views/components/ScrollOverflow.vue';

defineProps<{
  title: string;
  titleColor?: string;
}>();
</script>

<style lang="scss" scoped>
@use '@/ui/css/partial';

.profile-card-section {
  @extend %appear;

  display: flex;
  flex-direction: column;
  gap: var(--spacing-l);
  padding: var(--spacing-l) 0;
  overflow: hidden;

  h5 {
    margin: 0;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.15em;
    color: var(--color-white-30);
    text-transform: uppercase;
    display: flex;
    gap: 0.25rem;
    align-items: center;
    justify-content: flex-start;
    text-indent: 0.25em;
  }

  /* Same band as a handshake row. The top block is tinted so it separates from the header. */
  &:nth-child(odd) {
    background: linear-gradient(to right, transparent, var(--color-white-3), transparent);
  }

  .cards {
    display: flex;
    gap: 1rem;
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
    mask-image: linear-gradient(to right, transparent 0%, #000 1.25rem, #000 calc(100% - 1.25rem), transparent 100%);
  }

  .cards :deep(.gam-gambit-card),
  .cards :deep(.gam-gambit-result-skeleton),
  .cards :deep(.gambit-sentinel) {
    flex-shrink: 0;
    width: 18rem;
  }

  .cards :deep(.gam-gambit-card) {
    border: none;
  }
}
</style>
